const conversionFactor = 2.20462;

export const toKg = function(weight) {
  if(!weight) {
    return 0;
  }

  return weight / conversionFactor;
};

export const toLbs = function(weight, meet) {
  if(!weight) {
    return 0;

  }
  return weight * conversionFactor;
};
